export default "__VITE_ASSET__CdsEX3hY__"